






import { defineComponent, onMounted } from '@vue/composition-api'
import $http from '@/api'
import Cookies from 'js-cookie'

export default defineComponent({
  name: 'App',
  setup() {
    onMounted(async () => {
      try {
        const data = await $http.getPlatInfo()
        Cookies.set('platId', data.data.platId)
      } catch (error) {
        console.error(error)
      }
    })
  }
})
